import * as Sentry from '@sentry/react';
import { browserSession } from '../utils/browserSession';

const buildAppError = (name: string, message?: string) => {
  const error = new Error(message || name);
  error.name = name;
  return error;
};

const captureTokenIssue = (reason: string, extra?: Record<string, unknown>, originalError?: unknown) => {
  Sentry.withScope((scope) => {
    scope.setTag('module', 'request_auth');
    scope.setTag('issue_reason', reason);
    scope.setTag('page_path', window.location.pathname);
    scope.setTag('is_iframe', String(window.top !== window.self));

    scope.setContext('request_auth_debug', {
      href: window.location.href,
      origin: window.location.origin,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      localStorageAvailable: browserSession.isLocalStorageAvailable(),
      hasVerifyDataInBrowserSession: !!browserSession.getVerify(),
      hasVerifyTokenInBrowserSession: !!browserSession.getVerify()?.verifyToken,
      ...extra,
    });

    if (originalError instanceof Error) {
      Sentry.captureException(originalError);
    } else {
      Sentry.captureException(buildAppError(reason));
    }
  });
};

const userToken = (): any => {
  try {
    const verifyData = browserSession.getVerify();
    const verifyToken = verifyData?.verifyToken ?? null;

    if (!verifyToken) {
      captureTokenIssue('verify_token_not_available_for_request');
      return null;
    }

    return verifyToken;
  } catch (error) {
    captureTokenIssue(
      'failed_to_resolve_verify_token_for_request',
      {},
      error
    );

    return null;
  }
};

export default userToken;